import React from 'react'
import { renderBlok } from 'utils'

const StoryblokEntry = ({ pageContext }) => {
  const { story } = pageContext;
  const { name, slug } = story;
  const content = {
    name,
    slug,
    ...JSON.parse(story.content)
  }
  return <main role="main">{renderBlok(content)}</main>
}

export default StoryblokEntry
